<h1>{{ 'turbo.Bookings.RefundDialog.lblHeadline' | translate:'Refund payment' }}</h1>
<mat-dialog-content style="min-width: 400px;">
  <t4-container>
    <ng-container *ngIf="showForm">
      <div class="row">
        <div class="col-6" style="white-space:nowrap">{{ 'turbo.Bookings.RefundDialog.lblAmount' | translate : 'Paid amount'}}: </div>
        <div class="col-6" style="white-space:nowrap">{{payment.Amount | currency }}</div>
      </div>
      <div class="row">
        <div class="col-6" style="white-space:nowrap">{{ 'turbo.Bookings.RefundDialog.lblMethod' | translate : 'Method'}}: </div>
        <div class="col-6" style="white-space:nowrap">{{payment.Methods }}</div>
      </div>
      <div class="row">
        <div class="col-6" style="white-space:nowrap">{{ 'turbo.Bookings.RefundDialog.lblReference' | translate : 'Reference'}}: </div>
        <div class="col-6" style="white-space:nowrap">{{payment.Reference }}</div>
      </div>
      <div class="row" style="margin-top: 25px;">
        <div class="col-6" style="white-space:nowrap">{{ 'turbo.Bookings.RefundDialog.lblRemaining' | translate : 'Remaining amount'}}: </div>
        <div class="col-6" style="white-space:nowrap">{{payment.Amount - payment.Refunded | currency }}</div>
      </div>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'turbo.Bookings.RefundDialog.txtRefundAmount' | translate : 'Amount to refund'}}</mat-label>
        <input autocomplete="off" #txtInput type="number" required min="0" [max]="payment.Amount - payment.Refunded" matInput [(ngModel)]="refundAmount">
        <mat-error *ngIf="isInvalid">{{ 'turbo.Bookings.RefundDialog.errRefundAmountInvalid' | translate : 'Invalid amount'}}</mat-error>
        <mat-error *ngIf="isToHigh">{{ 'turbo.Bookings.RefundDialog.errRefundAmountToHigh' | translate : 'Amount cannot be higher than remaining amount'}}</mat-error>
        <mat-error *ngIf="isToLow">{{ 'turbo.Bookings.RefundDialog.errRefundAmountToLow' | translate : 'Amount cannot be lower than 0'}}</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{ 'turbo.Bookings.RefundDialog.txtRefundComment' | translate : 'Comment'}}</mat-label>
        <input autocomplete="off" #txtInput type="text"  matInput [(ngModel)]="message">
        </mat-form-field>

    </ng-container>
    <div *ngIf="showLoader" style="text-align: center; margin: 50px auto;">
      <mat-spinner mode="indeterminate" style="margin: auto"></mat-spinner>
      <br />
      <h2>{{ 'turbo.Bookings.RefundDialog.msgProcessing' | translate : 'Processing th refund...'}}</h2>
    </div>
    <div *ngIf="showResults" style="text-align: center; margin: 50px auto; max-width: 400px">
      <p *ngIf="!refundFailed">{{ 'turbo.Bookings.RefundDialog.msgSuccess' | translate : 'Amount has been refunded. If the original payment was processed through T4 the amount will be available for the customer shortly. '}}</p>
      <h2 *ngIf="refundFailed">{{ 'turbo.Bookings.RefundDialog.msgFailed' | translate : 'Refund failed. Please contact support'}}</h2>
    </div>
  </t4-container>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="col-xs-12" style="text-align: center">
    <button [disabled]="!message" mat-flat-button color="primary" style="margin: 3px;" (click)="validate()" *ngIf="showForm">{{ 'turbo.Bookings.RefundDialog.cmdConfirm' | translate : 'Ok'}}</button>
    <button mat-flat-button color="primary" style="margin: 3px;" (click)="close()" *ngIf="showResults">{{ 'turbo.Bookings.RefundDialog.cmdConfirm' | translate : 'Ok'}}</button>
  </div>
</mat-dialog-actions>
